import React, { useContext } from 'react';
import {DatasContext} from '../datas/DatasContext';
import { useTranslation } from 'react-i18next';
import Footer from './Footer';
import Divider from '@mui/material/Divider';
import { ThemeButton } from './ThemeButton';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Fab from '@mui/material/Fab';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';


export default function Outro() {
    const {content} = useContext(DatasContext);
    const { t } = useTranslation();
    return (
        <>
        {(content && content.outro) &&
        <div 
        className="flex bg-gray-200 text-sm leading-6 text-gray-900 pt-20 pb-6 px-6 min-w-80 w-80 h-svh overflow-hidden"
        id="outro" 
        style={{flexDirection:"column",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div>
                {/*{content.intro.contentTitle && <h2 className="text-md font-bold mb-0">{content.intro.contentTitle}</h2>}
                {content.intro.contentAuthor && <h3 className="mb-1">{content.intro.contentAuthor}</h3>}*/}
                {content.outro.title && <h2 className="text-3xl mb-0">{t('outro.title')}</h2>}
                {content.outro.subtitle && <h3 className="text-xl mb-4">{t('outro.subtitle')}</h3>}
                {content.outro.content && 
                    <>
                    <Divider/>
                    <div className="mt-4 mb-2 *:text-justify">
                    {content.outro.contentIntro && <div dangerouslySetInnerHTML={{__html: t('outro.contentIntro')}} />}
                    </div>
                    <TextDialog tro={content.outro} modalId="modal-outro-dialog"/>
                    </>
                    }
                 </div>
                <Footer/>
        </div>}
        </>
    )
}

export function TextDialog({tro, modalId}) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className="mb-4"> 
        <ThemeButton onClick={handleOpen} color="info" sx={{textDecoration:"underline",padding:0}}>{t('readmore')}</ThemeButton>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby={'title-'+modalId}
            disableScrollLock={true}
            keepMounted={true}
            hideBackdrop={true}
            fullScreen={true}
            fullWidth={true}>
            <Fab sx={{position:"absolute",top:"8px",right:"8px",height:"36px",width:"36px", boxShadow:"unset"}} size="small" color="default" onClick={handleClose}><CloseIcon/></Fab>
            <Box sx={{maxWidth:"650px",margin:"0 auto"}}>
            <DialogTitle id={'title-'+modalId}>
            {tro.contentTitle && <p className="text-xl mb-0 mt-4">{t('outro.contentTitle')}</p>}
            {tro.contentSubtitle && <p className="text-xl mb-2 font-normal">{t('outro.contentSubtitle')}</p>}
            </DialogTitle>
            <DialogContent sx={{
                '&':{textAlign:"justify"},
                '& p':{marginBottom:"1rem"

                }}}>
            {tro.content && <div dangerouslySetInnerHTML={{__html: t('outro.content')}} />}
            </DialogContent>
            </Box>
        </Dialog>
        </div>
    )

}